import { db } from "../../../../mp-database"

/**
 * Adds in destructured subtests to the userAssessment,
 * pulling from destructuredSubtests collection
 * @param {object} userAssessment
 * @returns {object} the userAssessment with destructuredSubtests added in
 */
export default function addDestructuredSubtests(userAssessment) {
  // get truthy subtests
  let subtestIds = []
  const keys = Object.keys(userAssessment.assessmentSubtests)
  keys.forEach(key => {
    if (userAssessment.assessmentSubtests[key]) {
      subtestIds.push(key)
    }
  })
  // for each subtest, get the destructuredSubtest data
  const fetches = subtestIds.map(id => {
    return db.collection("destructuredSubtests").doc(id).get()
  })
  return Promise.all(fetches).then(results => {
    let destructuredSubtests = {}
    results.forEach(doc => {
      if (doc.exists) {
        destructuredSubtests[doc.id] = doc.data()
      }
    })
    return {
      ...userAssessment,
      destructuredSubtests
    }
  })
}
